package org.example.zone360.pages.widgets.spiderChartModal


import SpiderChartForDashboard
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowDown
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getWidgetDetail
import kotlinx.browser.window
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.getAvatarColor
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun SpiderChartDetailsModal(
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    labels: List<String>,
    values: List<Int>,
    chartColor: String,
    score: Int,
    clubAvg: Int,
    coaches: WidgetDetailResponse?,
    widgetKey: String,
    isCoachPage: Boolean = false,
    onClose: () -> Unit
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    var selectedSortColumn by remember { mutableStateOf<String?>(null) }
    var isAscending by remember { mutableStateOf(true) }
    var localData by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var isLoading by remember { mutableStateOf(true) }

    // Add this after state declarations
    LaunchedEffect(Unit) {
        isLoading = true
        try {
            localData = getWidgetDetail(
                WidgetDetailPayload(
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    widgetKey = widgetKey
                )
            )
        } catch (e: Exception) {
            debugPrintln("Failed to fetch widget detail: ${e.message}")
        } finally {
            isLoading = false
        }
    }

    val effectiveData = coaches ?: localData
    val coachList = effectiveData?.coaches ?: emptyList()

    val sortedCoaches = when (selectedSortColumn) {
        "COACH" -> if (isAscending)
            coachList.sortedBy { it.coachName.lowercase() }  // ✅ Use coachList
        else
            coachList.sortedByDescending { it.coachName.lowercase() }
        "SCORE" -> if (isAscending)
            coachList.sortedBy { it.score }  // ✅ Use coachList
        else
            coachList.sortedByDescending { it.score }
        else -> coachList  // ✅ Use coachList
    }
    // Full-screen backdrop
    Box(
        modifier = Modifier
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("right", "0")
                property("bottom", "0")
                property("z-index", "99999")
                property("background-color", "rgba(0,0,0,0.7)")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
            .onClick { onClose() }
    ) {
        // Modal panel
        Box(
            modifier = Modifier
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .padding(24.px, if (breakpoint < Breakpoint.MD) 15.px else 25.px)
                .styleModifier {
                    property("width", "90%")
                    property("max-width", "450px")
                    property("max-height", "90vh")
                    property("overflow-y", "auto")
                    property("box-shadow", "0 20px 50px rgba(0,0,0,0.25)")
                }
                .onClick { it.stopPropagation() }
        ) {
            Column(modifier = Modifier.fillMaxWidth())
            {

                // ── Header: badge + title + close ──────────────────────────
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 12.px)
                ) {
                    Box(
                        modifier = Modifier
                            .width(28.px)
                            .height(28.px)
                            .backgroundColor(widgetColor)
                            .borderRadius(6.px)
                            .margin(right = 10.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = widgetNo.toString(),
                            fontSize = 14.px,
                            fontWeight = 700,
                            color = sitePalette.bodyBackgroundSecondary.rgb
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = widgetName,
                        fontSize = 18.px,
                        fontWeight = 700
                    )
                    Box(modifier = Modifier.styleModifier { property("flex", "1") })
                    Box(
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() }
                    ) {
                        SpanText(
                            text = "✕",
                            modifier = Modifier.fontSize(18.px).fontWeight(700)
                        )
                    }
                }

                // ── Spider Chart ───────────────────────────────────────────
                if (isLoading) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(300.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            ProgressIndicator(size = 30.px)
                            FieldTitleTextNormalSimple(
                                text = "Loading data...",
                                fontSize = 16.px,
                                color = Color.rgb(107, 114, 128),
                                marginTop = 12.px
                            )
                        }
                    }
                } else {
                    Box(
                        modifier = Modifier.fillMaxWidth(),
                        contentAlignment = Alignment.Center
                    ) {
                        SpiderChartForDashboard(
                            chartId = "spider_modal_${widgetNo}",
                            labels = labels,
                            values = values,
                            color = chartColor,
                            score = score,
                            clubAvg = clubAvg,
                            chartHeight = if (breakpoint < Breakpoint.MD) 180 else 230,
                            showScore = true,
                            fillOpacity = 0.25,
                            maxValue = 100,
                            isCoachPage = isCoachPage,
                            showSelection = false
                        )
                    }
                }

                // ── Sortable Table ─────────────────────────────────────────
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .borderRadius(12.px)
                        .styleModifier {
                            property("border", "1px solid #E5EAF3")
                            property("overflow", "hidden")
                        }
                )
                {
                    // Table header
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .gap(10.px)
                            .backgroundColor(Color.rgb(248, 250, 252))
                            .padding(leftRight = 20.px, topBottom = 10.px)
                            .borderBottom(1.px, LineStyle.Solid, Color.rgb(229, 234, 243)),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        val headers = listOf("COACH", "SCORE")

                        headers.forEachIndexed { index, label ->
                            Row(
                                modifier = Modifier
                                    .width(
                                        when {
                                            index == 0 && window.screen.width < 768 -> 115.px
                                            index == 0 -> 170.px
                                            else -> 80.px
                                        }
                                    )
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        if (selectedSortColumn == label) isAscending = !isAscending
                                        else { selectedSortColumn = label; isAscending = true }
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = label,
                                    fontSize = 11.px,
                                    fontWeight = 700,
                                    color = Color.rgb(107, 114, 128)
                                )
                                if (selectedSortColumn == label) {
                                    Box(modifier = Modifier.margin(left = 5.px)) {
                                        if (isAscending) {
                                            FaArrowUp(
                                                modifier = Modifier
                                                    .fontSize(10.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            )
                                        } else {
                                            FaArrowDown(
                                                modifier = Modifier
                                                    .fontSize(9.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // Table body
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(260.px)
                            .overflow(Overflow.Auto)
                    ) {
                        sortedCoaches.forEachIndexed { rowIndex, coach ->
                            val avatarColor = getAvatarColor(coach.coachName)

                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .gap(10.px)
                                    .backgroundColor(
                                        if (rowIndex % 2 == 0) Colors.White
                                        else Color.rgb(250, 251, 252)
                                    )
                                    .padding(
                                        leftRight = if (breakpoint < Breakpoint.MD) 10.px else 20.px,
                                        topBottom = 10.px
                                    )
                                    .borderBottom(1.px, LineStyle.Solid, Color.rgb(241, 245, 249)),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {

                                // Coach column
                                Row(
                                    modifier = Modifier.width(
                                        if (window.screen.width < 768) 150.px else 190.px
                                    ),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    val initials = coach.coachName
                                        .split(" ")
                                        .take(1)
                                        .joinToString("") { it.firstOrNull()?.toString() ?: "" }
                                        .uppercase()

                                    Box(
                                        modifier = Modifier
                                            .width(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .height(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .backgroundColor(avatarColor.bg)
                                            .borderRadius(50.percent)
                                            .margin(right = 10.px),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        SpanText(
                                            text = initials,
                                            modifier = Modifier
                                                .fontSize(11.px)
                                                .fontWeight(700)
                                                .color(avatarColor.text)
                                        )
                                    }

                                    SpanText(
                                        text = coach.coachName,
                                        modifier = Modifier
                                            .fontSize(13.px)
                                            .fontWeight(500)
                                            .overflow(Overflow.Hidden)
                                            .whiteSpace(WhiteSpace.NoWrap)
                                            .styleModifier {
                                                property("text-overflow", "ellipsis")
                                            }
                                    )
                                }

                                // Score column
                                FieldTitleTextNormalSimple(
                                    text = "${coach.score}",
                                    width = 80.px,
                                    fontSize = 11.px,
                                    fontWeight = 500
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}